"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _EventDispatcher = _interopRequireDefault(require("../event/EventDispatcher"));

var _ApiRequest = _interopRequireDefault(require("../network/api/ApiRequest"));

var _utils = require("../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };

    return extendStatics(d, b);
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

/**
 * A `Permissions` object is responsible for requesting and storing access permissions information
 * associated with an Aeris API account.
 */
var Permissions =
/** @class */
function (_super) {
  __extends(Permissions, _super);
  /**
   * Initializes a permissions object for an account associated with the specified client id
   * and secret.
   *
   * @param id
   * @param secret
   */


  function Permissions(id, secret) {
    var _this = _super.call(this) || this;

    _this.loading = false;
    _this.id = id;
    _this.secret = secret;

    _this.get();

    return _this;
  }
  /**
   * Returns a Promise containing the permissions data, fetching the data from the API initially
   * if required.
   */


  Permissions.prototype.get = function () {
    var _this = this;

    return new Promise(function (resolve, reject) {
      // always return a copy of our data object in case callers change the data contained within
      if (_this.hasLoaded()) {
        resolve((0, _utils.cloneDeep)(_this.permissions));
      } else if (_this.loading) {
        _this.on('load:done', function () {
          resolve((0, _utils.cloneDeep)(_this.permissions));
        });
      } else {
        _this.loading = true;

        _this.trigger('load:start');

        var request = new _ApiRequest.default({
          client: {
            id: _this.id,
            secret: _this.secret
          }
        });
        request.endpoint('oauth2/permissions').get().then(function (result) {
          _this.loading = false;

          if (result.data) {
            _this.permissions = result.data;
            _this.cached = new Date();
          }

          resolve((0, _utils.cloneDeep)(_this.permissions));

          _this.trigger('load:done');
        });
      }
    });
  };
  /**
   * A Boolean value indicating if permissions data is currently being requested from the API.
   */


  Permissions.prototype.isLoading = function () {
    return this.loading;
  };
  /**
   * A Boolean value indicating if permissions have been loaded.
   */


  Permissions.prototype.hasLoaded = function () {
    return this.permissions != null;
  };
  /**
   * Returns whether the account has access to the specified endpoint or destination.
   * @param endpoint
   */


  Permissions.prototype.canAccess = function (endpoint) {
    var result = (0, _utils.get)(this.permissions, endpoint);

    if (result) {
      return result.allow;
    }

    return false;
  };

  return Permissions;
}(_EventDispatcher.default);

var _default = Permissions;
exports.default = _default;
module.exports = exports.default;